import React, { useEffect, useState } from "react";
import "./Comments.css";

function Comments({ apiEndpoint }) {
  const [comments, setComments] = useState([]);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  useEffect(() => {
    fetch(apiEndpoint)
      .then((res) => res.json())
      .then((data) => setComments(data))
      .catch((err) => console.error(err));
  }, [apiEndpoint]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.message.trim()) return;

    const res = await fetch(apiEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await res.json();
    setComments([data, ...comments]);
    setFormData({ name: "", email: "", message: "" });
  };

  const handleLike = async (id) => {
    const res = await fetch(`${apiEndpoint}/${id}/like`, { method: "PUT" });
    const updated = await res.json();
    setComments(comments.map((c) => (c._id === id ? updated : c)));
  };

  const handleReply = async (id, replyMessage) => {
    if (!replyMessage.trim()) return;
    const res = await fetch(`${apiEndpoint}/${id}/reply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: "Guest", message: replyMessage }),
    });
    const updated = await res.json();
    setComments(comments.map((c) => (c._id === id ? updated : c)));
  };

  return (
    <section className="comments-section">
      <h2>Community Comments</h2>

      <form className="comment-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email (optional)"
          value={formData.email}
          onChange={handleChange}
        />
        <textarea
          name="message"
          placeholder="Write your comment..."
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit">Post Comment</button>
      </form>

      <div className="comment-list">
        {comments.length === 0 ? (
          <p className="no-comments">No comments yet. Be the first!</p>
        ) : (
          comments.map((c) => (
            <div key={c._id} className="comment">
              <div className="comment-header">
                <div className="avatar">{c.name.charAt(0).toUpperCase()}</div>
                <div>
                  <h4>{c.name}</h4>
                  <small>{new Date(c.date).toLocaleString()}</small>
                </div>
              </div>

              <p className="comment-text">{c.message}</p>

              <div className="comment-actions">
                <button onClick={() => handleLike(c._id)}>👍 {c.likes}</button>
              </div>

              <ReplyBox onReply={(msg) => handleReply(c._id, msg)} />

              {c.replies.length > 0 && (
                <div className="replies">
                  {c.replies.map((r, i) => (
                    <div key={i} className="reply">
                      <strong>{r.name}</strong>: {r.message}
                      <small>{r.date}</small>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
}

function ReplyBox({ onReply }) {
  const [reply, setReply] = useState("");
  return (
    <div className="reply-box">
      <textarea
        value={reply}
        onChange={(e) => setReply(e.target.value)}
        placeholder="Write a reply..."
      ></textarea>
      <button
        onClick={() => {
          onReply(reply);
          setReply("");
        }}
      >
        Reply
      </button>
    </div>
  );
}

export default Comments;
